export default "<p>\r\n  menu works!\r\n</p>\r\n";